import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Icons from "lucide-react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const STATUS = {
  Pending: "bg-amber-500", "In-Progress": "bg-blue-500", Completed: "bg-emerald-500",
};

export default function Track() {
  const { token } = useParams();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    axios.get(`${BACKEND}/api/esd/track/${token}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [token]);

  if (data === undefined) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (data === null) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-slate-300">
      <div className="text-center"><Icons.SearchX className="h-10 w-10 mx-auto mb-3 text-slate-500" /><div className="font-semibold">Tracking record not found</div></div>
    </div>
  );

  const Row = ({ k, v }) => <div className="flex justify-between py-1.5 border-b border-slate-100 text-sm"><span className="text-slate-500">{k}</span><span className="text-slate-800 font-medium text-right">{v || "—"}</span></div>;
  return (
    <div className="min-h-screen bg-slate-900 py-10 px-4" data-testid="track-page">
      <div className="max-w-md mx-auto">
        <div className="flex items-center gap-2.5 mb-5">
          <div className="h-10 w-10 rounded-xl bg-amber-500 flex items-center justify-center"><Icons.HardHat className="h-5 w-5 text-slate-900" /></div>
          <div><div className="text-white font-semibold">ESD Live Tracking</div><div className="text-slate-400 text-xs">Equipment Solutions Department</div></div>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-xl">
          <div className="flex items-center justify-between mb-4">
            <div><div className="font-mono text-sm text-slate-500">{data.reference}</div><div className="text-lg font-semibold text-slate-900">{data.equipment_code}</div></div>
            <span className={`text-white text-xs font-medium rounded-full px-3 py-1 ${STATUS[data.status] || "bg-slate-500"}`} data-testid="track-status">{data.status}</span>
          </div>
          <Row k="Equipment" v={data.equipment_name} />
          <Row k="Category" v={data.category} />
          <Row k="Capacity" v={data.capacity} />
          <Row k="Project" v={data.project_name} />
          <Row k="Destination" v={data.destination} />
          <Row k="Company" v={data.company_name} />
          <Row k="Operator" v={data.operator_name} />
          <Row k="Condition" v={data.condition} />
          <Row k="Photos on file" v={String(data.photo_count || 0)} />
          <div className="mt-4">
            <div className="text-xs font-medium text-slate-600 mb-2">Handover signatures</div>
            {["coordinator", "operator", "receiver"].map((s) => (
              <div key={s} className="flex items-center justify-between py-1 text-sm">
                <span className="capitalize text-slate-500">{s}</span>
                {data.signatures?.[s] ? <span className="text-emerald-600 inline-flex items-center gap-1"><Icons.CheckCircle2 className="h-4 w-4" /> {data.signatures[s].printed_name}</span> : <span className="text-slate-400 text-xs">Pending</span>}
              </div>
            ))}
          </div>
        </div>
        <div className="text-center text-slate-500 text-[11px] mt-4">Generated by the ESD platform · PIVI</div>
      </div>
    </div>
  );
}
